import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  SCROLLBAR_STYLES,
} from "../../../../constants/Styles";

export const MessagesFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1rem;
`;

export const MessageContainer = styled.div<{ maxHeight?: string }>`
  display: flex;
  flex-direction: column-reverse;
  gap: 0.5rem;
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight};`}
  overflow: auto;
  overflow-anchor: none;
  ${SCROLLBAR_STYLES};
`;

export const Anchor = styled.div`
  overflow-anchor: auto;
`;

export const MessageLineItem = styled.div<{
  messageBelongsToUser: boolean;
}>`
  font-size: ${FONT_SIZE.size12};
`;

export const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
`;

export const Message = styled.div<{
  messageBelongsToUser: boolean;
}>`
  background-color: ${({ messageBelongsToUser }) =>
    messageBelongsToUser ? COLORS.linkBlue : COLORS.secondaryLight};
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  width: 70%;
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

export const MessageRow = styled.div<{ messageBelongsToUser: boolean }>`
  display: flex;
  justify-content: ${({ messageBelongsToUser }) =>
    messageBelongsToUser ? "flex-end" : "flex-start"};
`;

export const MessageContent = styled.div`
  font-size: ${FONT_SIZE.size16};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  a {
    color: ${COLORS.secondary};
  }
`;

export const MessageLinks = styled.div<{ messageBelongsToUser: boolean }>`
  display: flex;
  flex-direction: column;
  font-size: ${FONT_SIZE.size12};
  align-items: ${({ messageBelongsToUser }) =>
    messageBelongsToUser ? "flex-end" : "flex-start"};
`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;
